import { useMutation } from '@tanstack/react-query';
import { ApiError } from '@src/services/api';
import { sendMessagesBatch } from './api';
import { ApiTypes } from 'common';
import { queryClient, QUERY_KEYS } from '@src/query';
import { conversationUId } from '@src/utils/conversation';

export const useMutationMessageBatchCreate = () =>
  useMutation<any, ApiError, {
    body: string;
    networkName: string;
    peers: { interlocutorId: string; senderAccountId: string }[];
  }>({
    mutationFn: (params) => sendMessagesBatch(params),
    onSuccess: async (_, params) => {
      for (const peer of params.peers) {
        queryClient.invalidateQueries({
          queryKey: QUERY_KEYS.conversationMessages(
            conversationUId(peer.senderAccountId, peer.interlocutorId),
          ),
        });
      }
    },
  });
